/* global axios */
import WhatsAppSipApiClient from './index';

class OutboundCallsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('outbound_calls');
  }

  create(data) {
    return axios.post(this.url, data);
  }

  complete(id, data) {
    return axios.put(`${this.url}/${id}`, data);
  }
}

export default new OutboundCallsAPI();
